const {
  detectDeviceType,
  detectBot,
  detectGoogleBot,
  isIpad,
  isIphone,
  isIpod,
  isAndroid,
} = require("./device-detection/index");
const checkBotAndType = (request) => {
  const userAgent = request ? request.headers["user-agent"] : navigator.userAgent;
  const isBot = detectBot(userAgent);
  const isGoogleBot = detectGoogleBot(userAgent);
  const deviceType = detectDeviceType(userAgent);
  let deviceSubType;

  if (isIpad(userAgent)) {
    deviceSubType = "IPAD";
  } else if (isIphone(userAgent)) {
    deviceSubType = "IPHONE";
  } else if (isIpod(userAgent)) {
    deviceSubType = "IPOD";
  } else if (isAndroid(userAgent)) {
    deviceSubType = "ANDROID";
  }

  return { isBot, isGoogleBot, deviceType, deviceSubType };
};
const checkBotAndTypeForLogs = (userAgent) => {
  const isBot = detectBot(userAgent);
  const isGoogleBot = detectGoogleBot(userAgent);
  const deviceType = detectDeviceType(userAgent);
  let deviceSubType;

  if (isIpad(userAgent)) {
    deviceSubType = "IPAD";
  } else if (isIphone(userAgent)) {
    deviceSubType = "IPHONE";
  } else if (isIpod(userAgent)) {
    deviceSubType = "IPOD";
  } else if (isAndroid(userAgent)) {
    deviceSubType = "ANDROID";
  }

  return { isBot, isGoogleBot, deviceType, deviceSubType };
};
module.exports = { checkBotAndType, checkBotAndTypeForLogs };
